import { create } from "zustand";

export interface DebugEvent {
  id: string;
  timestamp: number;
  category: string;
  message: string;
  data?: Record<string, any>;
}

interface MobileDebugStore {
  events: DebugEvent[];
  log: (category: string, message: string, data?: Record<string, any>) => void;
  clear: () => void;
}

const MAX_EVENTS = 50;

export const useMobileDebugStore = create<MobileDebugStore>((set) => ({
  events: [],

  log: (category, message, data) => {
    // Only log if debug mode is active (check once at log time)
    if (typeof window === "undefined") return;
    if (new URLSearchParams(window.location.search).get("debug") !== "1") return;

    const event: DebugEvent = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      timestamp: Date.now(),
      category,
      message,
      data,
    };

    set((state) => ({
      events: [...state.events, event].slice(-MAX_EVENTS),
    }));
  },

  clear: () => set({ events: [] }),
}));

/**
 * Standalone function to log debug events without needing hooks.
 * Safe to call anywhere - no-ops if debug mode is not active.
 */
export function mobileDebugLog(
  category: string,
  message: string,
  data?: Record<string, any>
): void {
  useMobileDebugStore.getState().log(category, message, data);
}
